import { render, staticRenderFns } from "./KrausSelect.vue?vue&type=template&id=763b685f&lang=pug&"
import script from "./KrausSelect.vue?vue&type=script&lang=js&"
export * from "./KrausSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports